import {
  CompanyHostDeviceEntity,
  CompanyHostDeviceId,
  CompanyName,
  companyHostDeviceId,
  companyName,
} from '@edgvr-front/companies/domain';
import { Validate } from '@edgvr-front/util/validate';

export class CompanyHostDeviceDisableResponseDTO {
  private static validation = Validate.compile(
    CompanyHostDeviceDisableResponseDTO.validationSchema(),
    CompanyHostDeviceEntity
  );

  constructor(readonly data: CompanyHostDeviceDisableResponse) {
    Validate.assert(CompanyHostDeviceDisableResponseDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: 'object',
      required: ['device'],
      properties: {
        device: {
          instanceof: CompanyHostDeviceEntity.name,
        },
      },
    };
  }
}

interface CompanyHostDeviceDisableResponse {
  device: CompanyHostDeviceEntity;
}
